import Icon from 'vue-awesome/components/Icon'

Icon.register({
  signal_cellular_off_rounded: {
    paths: [
      {
        d: 'M21 3.41c0-.89-1.08-1.34-1.71-.71l-6.6 6.6L21 17.61V3.41zm.44 17.47L5.62 5.06a.996.996 0 10-1.41 1.41l5.66 5.66-7.16 7.16c-.63.63-.19 1.71.7 1.71h15.32l1.29 1.29c.39.39 1.02.39 1.41 0 .4-.39.4-1.02.01-1.41z'
      }
    ],
    width: '24',
    height: '24'
  }
})
